import { heroChips } from "@/mocks/home";

export default function Hero() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden md:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20dark%20interior%20with%20warm%20amber%20light%20rays%20through%20sheer%20window%20curtain%2C%20deep%20brown%20and%20terracotta%20shadows%2C%20moody%20atmospheric%20film%20still%2C%20soft%20smoke%20and%20dust%20in%20light%20beams%2C%20artistic%20abstract%20composition&width=1920&height=1080&seq=hero-cinema-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-6 py-28 text-center md:py-32 animate-fade-up">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-1.5 text-xs font-label text-background-100 ring-1 ring-background-50/25">
          <i className="ri-play-circle-fill text-accent-400"></i>
          影视在线观看信息整理
        </span>
        <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          善良的小姨子在线
          <span className="mt-3 block text-xl font-semibold text-accent-300 md:text-3xl">
            在线观看 · 在线播放 · 高清在线
          </span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          本站围绕「善良的小姨子在线观看」整理了一条清晰的信息路径：先了解剧情与主题，再对比高清在线、免费在线与完整版、无删减之间的差别，最后选择合适的播放线路开始观看。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {heroChips.map((chip) => (
            <span
              key={chip}
              className="rounded-full bg-background-50/10 px-3 py-1 text-xs font-label text-background-100 ring-1 ring-background-50/20"
            >
              {chip}
            </span>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => jump("playlines")}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            <i className="ri-play-fill text-base"></i>
            查看播放线路
          </button>
          <button
            type="button"
            onClick={() => jump("versions")}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-7 py-3 text-sm font-label text-background-50 ring-1 ring-background-50/30 transition-colors hover:bg-background-50/20 sm:w-auto cursor-pointer"
          >
            <i className="ri-stack-line text-base"></i>
            了解版本差异
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 z-10 -translate-x-1/2 pb-6 text-background-100/70">
        <i className="ri-arrow-down-s-line animate-bounce text-2xl"></i>
      </div>
    </section>
  );
}